import { DataGenerator } from './DataGenerator';
import { Guid } from 'src/utility/guid';
import {
  GenericIncident, PriorityType
} from 'src/app/hickory-api';

export class GenericIncidentData extends DataGenerator<GenericIncident> {
  static instance = new GenericIncidentData();
  protected createPredefined(): GenericIncident[] {
    return [
      {
        id: '706a9f3a8edd4a6586018ac777e69e18',
        name: 'Attack',
        priority: PriorityType.Emergency
      },
      {
        id: '56ba883fe4f14ba48b497f8869c57c49',
        name: 'Bomb',
        priority: PriorityType.Emergency
      },
      {
        id: '7bd067dc62ea400b83b43e7145eca77b',
        name: 'Fire',
        priority: PriorityType.Emergency
      },
      {
        id: 'f85091479f96477ab6d7d15874348eb3',
        name: 'Wind',
        priority: PriorityType.NonEmergency
      }
    ];
  }

  protected createGenerated(): GenericIncident[] {
    const list: GenericIncident[] = [];
    for (let i = 0; i < 100; i++) {
      if (i % 2 === 0) {
        list.push(this.generate(i));
      } else {
        list.push(this.generateAlternate(i));
      }
    }
    return list;
  }

  private generate(i: number): GenericIncident {
    return {
      id: Guid.newGuid(),
      name: i + ' Generated Generic short',
      priority: PriorityType.Emergency
    };
  }

  private generateAlternate(i: number): GenericIncident {
    return {
      id: Guid.newGuid(),
      name: i + ' Generated Generic with a long incident name',
      priority: PriorityType.NonEmergency
    };
  }

  add(incident: GenericIncident) {
    incident.id = Guid.newGuid();
    this._manual.push(incident);
  }

  delete(id: string) {
    this._manual = this._manual.filter(i => i.id !== id);
    this._predefined = this._predefined.filter(i => i.id !== id);
    this._generated = this._generated.filter(i => i.id !== id);
  }
}
export const genericIncidentData = GenericIncidentData.instance;
